import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { pageProps } from '~/presentation/roles/adm/pages/ListAdministrator';
import { iStore, iUsers } from '~/domain/interfaces/models';
import { iAdministrator } from '~/domain/interfaces/models/Administrator';
import { getAgeFromBirthdate } from '~/utils/getAgeFromBirthdate';
import { iListRegisteredAdmin } from '../interface';

/**
 * Mapping of the appointment list data.
 *
 * @param Component component to connect.
 */
export function ConnectAdmin<P>(
  Component: ComponentType<P & pageProps>,
): React.FC<P> {
  const Render: React.FC<P> = ({ ...rest }) => {
    const admin = useSelector((store: iStore) => store.administrator);
    console.log('... adms mapper', admin);
    const { user } = useSelector((store: iStore) => store.auth.info);

    /* eslint no-param-reassign: "error" */
    Component.defaultProps = {
      // Default descending order for date
      data: _.orderBy(
        mapAdminData(admin, user?.id),
        item => {
          const splitDate = item.date.split('/');
          const internationalDate =
            splitDate.length < 3
              ? item.date
              : `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;

          return new Date(internationalDate).getTime();
        },
        ['desc'],
      ),
      ...(rest as P),
    };

    return <Component {...(rest as P & pageProps)} />;
  };

  return Render;
}

/**
 * component data mapper
 * @param appointment data.
 */
const mapAdminData = (
  admin: iAdministrator,
  userId?: number,
): iListRegisteredAdmin[] => {
  const arr: iListRegisteredAdmin[] = [];
  if (!(admin.results.length > 0)) return arr;

  admin.results.forEach(item => {
    const date = item.administrator.created.split('T')[0].split('-');
    const dateFormated = `${date[2]}/${date[1]}/${date[0]}`;

    const birthdate = new Date(item.user.birthdate);

    if (!userId || userId !== item.user.id)
      arr.push({
        avatar: item.user.avatar,
        cod: item.administrator.id.toString(),
        date: dateFormated,
        fullName: `${item.user.firstName} ${item.user.lastName}`,
        cpf: item.user.cpf,
        phone: item.user.phone,
        email: item.user.email,
        userId: item.user.id,
        org: item.org.name,
        status: item.administrator.situation,
        age: getAgeFromBirthdate(birthdate),
      });
  });

  return arr;
};
